<template>
  <div>
    <section>
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-5">
            <h1 class="text-uppercase">
              {{ translate("menu.manage_variety") }}
            </h1>
          </div>
          <div class="col-sm-7 d-flex justify-content-end align-items-center">
            <div class="card-tools">
              <div class="input-group input-group-sm">
                <div class="input-group">
                  <button
                    @click.prevent="clearSearch()"
                    class="btn btn-primary"
                    v-if="isInputSearch"
                  >
                    <i class="fas fa-undo"></i>
                  </button>
                  <input
                    type="text"
                    name="table_search"
                    class="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-default"
                    :placeholder="translate('menu.search')"
                    v-model="filter.search"
                    v-on:keyup.enter="searchKey()"
                  />

                  <button
                    type="button"
                    @click="searchKey()"
                    class="btn btn-primary"
                  >
                    <i class="fas fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-header">
            <div class="flex_head_table">
              <div class="change_list mx-auto">
                <div class="dropdown">
                  <button
                    class="btn btn-default tb_row_drop dropdown-toggle"
                    type="button"
                    id="showRow"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span class="tb_row_text"
                      >{{ translate("menu2.show") }} {{ filter.listNum }}
                      {{ translate("menu2.row") }}</span
                    >
                    <span class="icon-caret drop_caret"></span>
                  </button>
                  <div
                    class="
                      dropdown-menu dropdown-menu-right dropdown-menu-lg-left
                      show_list_dropdown
                    "
                    aria-labelledby="showRow"
                  >
                    <a class="dropdown-item" @click="changeList(5)">5</a>
                    <a class="dropdown-item" @click="changeList(10)">10</a>
                    <a class="dropdown-item" @click="changeList(50)">50</a>
                    <a class="dropdown-item" @click="changeList(100)">100</a>
                    <a class="dropdown-item" @click="changeList(200)">200</a>
                    <a class="dropdown-item" @click="changeList(1000)">1000</a>
                  </div>
                </div>
              </div>

              <div class="mx-auto col bg_exel"><ImportExcelScore /></div>
              <div class="title mx-auto">
                <button
                  class="btn btn-add mr-2 excel_color"
                  @click="onExport()"
                  data-toggle="tooltip"
                  data-placement="left"
                  :title="
                    translate('menu.sample_file_import_coffee_variety_scores')
                  "
                  type="button"
                >
                  <i class="fa-solid fa-file-excel"></i> Export Exel
                </button>
                <button class="btn btn-add" @click="openModal()">
                  <i class="fas fa-plus"></i>
                  {{ translate("menu.Add") }}
                </button>
              </div>
              <!-- test -->
            </div>
            <!-- <div class="d-flex"> -->
            <!-- <div class="mr-auto change_list">
                <div class="dropdown">
                  <button
                    class="btn btn-default tb_row_drop dropdown-toggle"
                    type="button"
                    id="showRow"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span class="tb_row_text"
                      >{{ translate("menu2.show") }} {{ filter.listNum }}
                      {{ translate("menu2.row") }}</span
                    >
                    <span class="icon-caret drop_caret"></span>
                  </button>
                  <div
                    class="
                      dropdown-menu dropdown-menu-right dropdown-menu-lg-left
                      show_list_dropdown
                    "
                    aria-labelledby="showRow"
                  >
                    <a class="dropdown-item" @click="changeList(5)">5</a>
                    <a class="dropdown-item" @click="changeList(10)">10</a>
                    <a class="dropdown-item" @click="changeList(50)">50</a>
                    <a class="dropdown-item" @click="changeList(100)">100</a>
                    <a class="dropdown-item" @click="changeList(200)">200</a>
                    <a class="dropdown-item" @click="changeList(1000)">1000</a>
                  </div>
                </div>
              </div> -->
            <!--
              <div class="title">
                <button class="btn btn-add" @click="openModal()">
                  <i class="fas fa-plus"></i>
                  {{ translate("menu.Add") }}
                </button>
              </div> -->
            <!-- </div> -->
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table
                class="table table-bordered table-hover table-striped sortTable"
              >
                <thead>
                  <tr>
                    <td width="5%">
                      <label>{{ translate("menu.No") }}</label>
                    </td>
                    <td width="10%">
                      <label>{{ translate("menu.Name") }}</label>
                    </td>
                    <td width="30%">
                      <label>{{ translate("menu.Address") }}</label>
                    </td>
                    <td width="20%">
                      <label>{{ translate("menu.Location") }}</label>
                    </td>
                    <td width="20%">
                      <label>{{ translate("menu.variety_name") }}</label>
                    </td>
                    <td width="10%">
                      <label>{{ translate("menu.processing") }}</label>
                    </td>
                    <td width="5%">
                      <label>{{ translate("menu.code") }}</label>
                    </td>
                    <td width="10%">
                      <label>{{ translate("menu.Action") }}</label>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in sortedItems" :key="index">
                    <td>
                      {{ data.order }}
                    </td>
                    <td>
                      {{ data.name }}
                    </td>
                    <td>
                      {{ data.postcode }}, {{ data.province }},
                      {{ data.district }},
                      {{ data.subdistrict }}
                    </td>
                    <td>
                      {{ data.location }}
                    </td>
                    <td>
                      {{ data.variety }}
                    </td>
                    <td>
                      {{ data.process }}
                    </td>
                    <td>
                      {{ data.code }}
                    </td>
                    <td style="display: flex">
                      <button class="btn btn-action" @click="gotoScores(data)">
                        <i class="fas fa-folder-open"></i>
                      </button>
                      <button class="btn btn-action" @click="edit(data)">
                        <i class="fas fa-edit btn-edit"></i>
                      </button>
                      <button class="btn btn-action" @click="del(data)">
                        <i class="fas fa-trash-alt btn-delete"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- pagination -->
            <div class="row">
              <div class="col-md-8">
                <nav>
                  <ul class="pagination">
                    <li
                      class="page-item"
                      :class="{ disabled: !pagination.first_link }"
                    >
                      <a
                        href="#"
                        @click="getData(pagination.first_link)"
                        class="page-link"
                      >
                        <span aria-hidden="true">&laquo;</span>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: !pagination.prev_link }"
                    >
                      <a
                        href="#"
                        @click="getData(pagination.prev_link)"
                        class="page-link"
                      >
                        <span aria-hidden="true">&#8249;</span>
                      </a>
                    </li>
                    <template
                      v-for="(pageNumber, index) in pagination.last_page"
                    >
                      <li
                        :key="index"
                        v-if="
                          Math.abs(pageNumber - pagination.current_page) < 3 ||
                          pageNumber === pagination.last_page ||
                          pageNumber == 1
                        "
                        class="page-item"
                        :class="{
                          active: pagination.current_page == pageNumber,
                        }"
                      >
                        <a
                          href="#"
                          @click="getData(pagination.path_page + pageNumber)"
                          class="page-link pagi_link"
                          :class="{
                            last:
                              pageNumber == pagination.last_page &&
                              Math.abs(pageNumber - pagination.current_page) >
                                3,
                            first:
                              pageNumber == 1 &&
                              Math.abs(pageNumber - pagination.current_page) >
                                3,
                          }"
                          >{{ pageNumber }}</a
                        >
                      </li>
                    </template>

                    <li
                      class="page-item"
                      :class="{ disabled: !pagination.next_link }"
                    >
                      <a
                        href="#"
                        @click="getData(pagination.next_link)"
                        class="page-link"
                      >
                        <span aria-hidden="true">&#8250;</span>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: !pagination.last_link }"
                    >
                      <a
                        href="#"
                        @click="getData(pagination.last_link)"
                        class="page-link"
                      >
                        <span aria-hidden="true">&raquo;</span>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
              <div class="col-md-4 d-flex justify-content-end">
                <div>
                  {{ translate("menu2.page") }}: {{ pagination.from_page }} -
                  {{ pagination.to_page }} {{ translate("menu2.total") }}:
                  {{ pagination.total_page }}
                </div>
              </div>
            </div>
            <!-- pagination -->
          </div>
        </div>
      </div>
    </section>
    <ModalVariety ref="modalvariety" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ModalVariety from "./ModalVariety.vue";
import ImportExcelScore from "./ImportExcelScore";
export default {
  components: {
    ModalVariety,
    ImportExcelScore,
  },
  props: [],

  data() {
    return {
      variety: [],
      api_url: "/api/coffeespot-varieties",
      pagination: {},
      pagi: "",
      filter: {
        pagiurl: "",

        listNum: "",
        search: "",
      },
      isInputSearch: false,
      sort: {
        key: "",
        isAsc: false,
      },
    };
  },
  computed: {
    ...mapGetters(["allCoffeespotVarietie"]),
    sortedItems() {
      const list = this.allCoffeespotVarietie.slice();
      for (let i = 0; i < list.length; i++) {
        list[i].order = this.$getOverallIndex(i, this.pagination);
      }
      if (!!this.sort.key) {
        list.sort((a, b) => {
          a = a[this.sort.key];
          b = b[this.sort.key];

          return (a === b ? 0 : a > b ? 1 : -1) * (this.sort.isAsc ? 1 : -1);
        });
      }

      return list;
    },
  },
  watch: {
    filter: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val.search) {
          this.isInputSearch = true;
        } else {
          this.isInputSearch = false;
        }
      },
    },
  },

  mounted() {
    this.filter.listNum = this.$cookies.get("managevariety_listnum");
    this.getData(this.api_url);
    Fire.$on("fetchupdateCoffeespotVarietie", () => {
      this.getData(this.api_url);
    });
  },

  methods: {
    ...mapActions(["deleteCoffeespotVarietie", "getCoffeespotVarietie"]),
    onExport() {
      axios
        .post("/api/excel/export-score", this.filter, { responseType: "blob" })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "exportScore.xlsx"); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
    },

    del(data) {
      swal
        .fire({
          title: this.translate("menu.are_you_sure?"),
          text: `${this.translate("menu.do_you_really_want_to_delete")} ${
            data.variety
          }  ${this.translate("menu.from_coffee_spot_information")}`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          cancelButtonText: this.translate("menu.cancel"),
          confirmButtonText: this.translate("menu.yes_delete"),
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.deleteCoffeespotVarietie(data.varieties_id).then(
              (response) => {
                if (response.data.success) {
                  swal.fire(
                    this.translate("menu.deleted"),
                    this.translate("menu.your_information_has_been_deleted"),
                    "success"
                  );
                } else {
                  swal.fire({
                    icon: "error",
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 2000,
                  });
                }
              }
            );
          }
        });
    },
    edit(data) {
      let EditData = { ...data };
      this.$refs.modalvariety.openModal(EditData);
    },
    openModal() {
      this.$refs.modalvariety.openModal();
    },
    gotoScores(data) {
      let obj = { name: data.name, id: data.varieties_id };
      this.$router.push({
        path: `evaluation/${data.varieties_id}`,
        query: obj,
      });
    },

    getOverallIndex(index) {
      return (
        this.pagination.current_page * this.pagination.per_page -
        this.pagination.per_page +
        index +
        1
      );
    },
    searchKey() {
      this.filter.pagiurl = this.api_url;
      this.getData(this.filter.pagiurl);
    },
    clearSearch() {
      this.filter.search = "";
      this.getData(this.filter.pagiurl);
    },
    changeList(num) {
      this.$cookies.set("managevariety_listnum", num);
      this.filter.listNum = num;
      this.getData(this.filter.pagiurl);
    },
    getData(pagi) {
      this.filter.pagiurl = pagi || this.api_url;
      this.getCoffeespotVarietie(this.filter)
        .then((response) => {
          //   this.variety = response.data.message.data;
          this.filter.listNum = response.data.listNum;
          this.pagination = this.$paginate(response.data.message);
        })
        .catch((error) => {
          if (error.response) {
            swal.fire(
              this.translate("menu2.error"),
              error.response.data.message,
              "warning"
            );
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-action {
  background-color: #f0f0f0;
  border-radius: 10px;
  margin: 3px;
  .btn-edit {
    color: green;
  }
  .btn-delete {
    color: red;
  }
}

.title {
  display: flex;
  flex-direction: row;
  //   flex-wrap: wrap;
  align-content: flex-end;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.btn-add {
  height: 40px;
  text-align: center;
  background: #55b2be;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 20px;
  color: white;
  font-size: 16px;

  & i {
    margin-right: 9px;
    font-size: 20px;
  }
}
.excel_color {
  background: #62c483;
  transition: all 0.2s;
  &:hover {
    background: #1f5331 !important;
    transform: scale(1.05);
  }
}
.flex_head_table {
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 4px;
  @media (max-width: 816px) {
    flex-direction: column;
  }
}
</style>
